import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import {
  Card,
  Grid,
  Box,
  extendTheme,
  CardHeader,
  Heading,
  CardBody,
  Center,
  Image,
  Text,
  Stack,
  CardFooter,
  Button,
  ButtonGroup,
  Divider,
  useEditable,
  SimpleGrid,
} from "@chakra-ui/react";

import api from "../../utils/ApiMethod";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Helmet } from "react-helmet";

const NationalAchievement = () => {
  const [data, setData] = useState([]);

  const radialGradient2 = "radial-gradient(circle, #ffefba, #ffffff);";

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/nationalAchievement");
      setData(data);
      // console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          National Sports Achievements Bihar | Bihar State Sports Authority |
          BSSA
        </title>
        <meta
          name="description"
          content="बिहार राज्य खेल प्राधिकरण की राष्ट्रीय उपलब्धियां: देखिये राज्य के खिलाड़ियों की सूची जिन्होंने विभिन्न राष्ट्रीय प्रतियोगिताओं में उत्कृष्ट प्रदर्शन कर राज्य का गौरव बढ़ाया है।"
        />
      </Helmet>
      <Breadcrumb
        pageName="National Achievements"
        pageTitle="National Achievements"
        id="#National-Achievements"
        img_url="./img/backdropImg/national achievement  a 11.12.2024.jpg"
        mobile_banner="./img/backdropImg/national achievement  mobile view a 11.12.2024.jpg"
      />
      <Heading p={8} fontSize="25px" background={radialGradient2}>
        राष्ट्रीय उपलब्धियां
      </Heading>

      {/* ------------------------------------horizontal Line---------------------------------------------------- */}
      <div
        style={{
          height: "4px",
          width: "100%",
          backgroundColor: " rgb(8, 44, 44)",
          paddingBottom: "3px",
        }}
      ></div>
      {/* ------------------------------------------------------------------------------------------------------- */}

      <Center background={radialGradient2}>
        <Grid
          templateColumns={["1fr", "1fr 1fr", "1fr 1fr 1fr", "1fr 1fr 1fr"]}
          gap={4}
          alignItems={"center"}
        >
          {data.map((item, index) => (
            <Box key={index} maxW="xl" p="2%">
              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  translateX: index % 2 === 0 ? -50 : 50,
                  translateY: -50,
                }}
                whileInView={{ opacity: 1, translateX: 0, translateY: 0 }}
                transition={{ duration: 0.3, delay: index * 0.2 }}
              >
                <Image
                  src={item.image}
                  alt="Green double couch with wooden legs"
                  borderRadius="lg"
                  height="100%"
                  width="100%"
                />
                <Stack mt="6" spacing="3">
                  <Heading size="md">{item.name}</Heading>
                  <Text>{item.achievement}</Text>
                </Stack>
              </motion.div>
            </Box>
          ))}
        </Grid>
      </Center>
    </div>
  );
};

export default NationalAchievement;
